<template>
<div>
    <v-btn small dark color="green darken-2" @click="dialog = true">Cấp mới</v-btn>
    <v-dialog v-model="dialog" max-width="600px">
      <v-card class="rounded-lg">
        <v-card-title>
          Cấp khu vực IP
        </v-card-title>
        <v-card-text>
          <v-form ref="assignForm" @submit.prevent="submitForm" class="mt-4">
            <v-row>
              <!-- Employee Code Autocomplete -->
              <v-col cols="12">
                <EmployeeAutocomplete
                  v-model="form.employeeCode"
                  :employees="employees"
                  :loading="loadingEmployees"
                />
              </v-col>
              <v-col cols="12">
                <v-select :items="types" v-model="form.type"
                outlined
                dense
                label="Phân loại"
                :rules="[v => !!v || 'Dữ liệu bắt buộc']"
                ></v-select>

              </v-col>

              <!-- Store Codes Textarea -->
              <v-col cols="12">
                <v-textarea
                  v-model="form.storeCodes"
                  label="Mã kho (mỗi mã trên một dòng)"
                  outlined
                  dense
                  rows="6"
                  required
                  :rules="[v => !!v || 'Mã kho là bắt buộc']"
                  placeholder="Nhập mã kho, mỗi mã trên một dòng, phân cách dấu ';'"
                />
              </v-col>
            </v-row>

            <!-- Form Actions -->
            <v-row class="mt-4">
              <v-col cols="12" class="d-flex justify-end gap-2">
                <v-btn depressed @click="resetForm" class="mx-2">Hủy</v-btn>
                <v-btn color="green darken-2" dark type="submit" :loading="submitting"  class="mx-2">
                  Cấp IP
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import http from "@/components/services/http-common";
import EmployeeAutocomplete from "@/components/Crud/EmployeeAutocomplete.vue";
import ApiServices from "@/components/services/ApiServices";
import {assignIp} from './api'

export default {
  name: 'AssignIp',
  components: {
    EmployeeAutocomplete
  },
  data() {
    return {
      dialog: false,
      form: {
        employeeCode: null,
        storeCodes: '',
        type: null
      },
      types: ['EXCEPTION', 'STANDARD', 'AM', 'RM', 'SO'],
      employees: [],
      employeeSearch: '',
      loadingEmployees: false,
      submitting: false
    }
  },
  computed: {
  },
  mounted() {
    this.fetchEmployees();
  },
  methods: {
    getAvatarColor(code) {
      const colors = ['#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8', '#F7DC6F', '#BB8FCE'];
      let hash = 0;
      for (let i = 0; i < code.length; i++) {
        hash = code.charCodeAt(i) + ((hash << 5) - hash);
      }
      return colors[Math.abs(hash) % colors.length];
    },
    fetchEmployees() {
      this.loadingEmployees = true;
      try {
        // TODO: Replace with actual API call later
        // const response = await http.get('employees/fetch/v2');
        // this.employees = response.data || [];

        // Temporary: Load dummy data once
        
      return ApiServices.getEmployee(true).then(r=>r.data).then(d => {
        console.log('employees:',d)
        this.employees = d.data
        // alert("xxxx")
      
      })
      } catch (error) {
        console.error('Error fetching employees:', error);
        this.$root.$emit('showSnackbar', {
          message: 'Lỗi khi tải danh sách nhân viên',
          color: 'error'
        });
      } finally {
        this.loadingEmployees = false;
      }
    },
    onEmployeeSelect(value) {
      console.log('Selected employee:', value);
    },
    async submitForm() {
      if (!this.$refs.assignForm.validate()) {
        return;
      }

      this.submitting = true;
      try {
        // Parse store codes from textarea (split by newline and filter empty lines)
        const storeCodesArray = this.form.storeCodes
          .split('\n')
          .map(code => code.trim())
          .filter(code => code.length > 0);

        const payload = {
          employeeCode: this.form.employeeCode,
          type: this.form.type,
          // storeCodes: storeCodesArray
          storeCodes: this.form.storeCodes
        };

        assignIp(payload).then(() =>  {
          this.resetForm();
          this.$emit('assigned');
        }).finally( () => {
          this.submitting = false;
        })
        
      } catch (error) {
        console.error('Error assigning IP:', error);
        this.$root.$emit('showSnackbar', {
          message: error.response?.data?.message || 'Lỗi khi cấp khu vực IP',
          color: 'error'
        });
      } finally {
        this.submitting = false;
      }
    },
    resetForm() {
      this.dialog = false;
      this.$refs.assignForm.reset();
      this.form = {
        employeeCode: null,
        storeCodes: ''
      };
      // this.employees = [];
    }
  }
}
</script>